import { EsgValue, EsgKpi, ReportingFrameworks } from './gql/graphql';

export enum EsgCategoryEnum {
  VEHICLE_FLEET = 'VEHICLE_FLEET',
  PURCHASED_ENERGY = 'PURCHASED_ENERGY',
  WATER = 'WATER',
  AGE_STRUCTURE = 'AGE_STRUCTURE',
  TRAINING = 'TRAINING',
  HEALTH_SAFETY = 'HEALTH_SAFETY',
  WASTE = 'WASTE',
  DISCRIMINATION = 'DISCRIMINATION',
  RAW_MATERIALS = 'RAW_MATERIALS',
  EMPLOYMENT_DIVERSITY = 'EMPLOYMENT_DIVERSITY',
  FINANCIAL = 'FINANCIAL',
  GOVERNANCE_BODIES = 'GOVERNANCE_BODIES',
  BUSINESS_CONDUCT = 'BUSINESS_CONDUCT',
  SELF_PRODUCED_ENERGY = 'SELF_PRODUCED_ENERGY',
  POLLUTION = 'POLLUTION',
  BIODIVERSITY = 'BIODIVERSITY',
  REMUNERATION = 'REMUNERATION',
  SUPPLY_CHAIN = 'SUPPLY_CHAIN',
  COMPANY_BUSINESS_CONDUCT = 'COMPANY_BUSINESS_CONDUCT',
  COMPANY_GOVERNANCE_BODIES = 'COMPANY_GOVERNANCE_BODIES',
  COMPANY_SUPPLY_CHAIN = 'COMPANY_SUPPLY_CHAIN',
  COMPANY_RESOURCE_USAGE_STRATEGY = 'COMPANY_RESOURCE_USAGE_STRATEGY',
  COMPANY_RESOURCE_INFLOW = 'COMPANY_RESOURCE_INFLOW',
  COMPANY_RESOURCE_OUTFLOW = 'COMPANY_RESOURCE_OUTFLOW',
  COMPANY_REPORT_BASICS = 'COMPANY_REPORT_BASICS',
  COMPANY_BUSINESS_INFORMATION = 'COMPANY_BUSINESS_INFORMATION',
  COMPANY_FINANCIAL = 'COMPANY_FINANCIAL',
  COMPANY_WORKFORCE_STRATEGY = 'COMPANY_WORKFORCE_STRATEGY',
  COMPANY_WORKFORCE_ENGAGEMENT = 'COMPANY_WORKFORCE_ENGAGEMENT',
  COMPANY_EMPLOYMENT_DIVERSITY = 'COMPANY_EMPLOYMENT_DIVERSITY',
  COMPANY_REMUNERATION = 'COMPANY_REMUNERATION',
  COMPANY_HEALTH_SAFETY = 'COMPANY_HEALTH_SAFETY',
  COMPANY_HUMAN_RIGHTS = 'COMPANY_HUMAN_RIGHTS',
  REFRIGERANTS = 'REFRIGERANTS',
  COMPANY_EMISSION_REDUCTION = 'COMPANY_EMISSION_REDUCTION',
}

export type TranslatedEsgKpi = EsgKpi & {
  esgValue?: EsgValue;
  translatedKpiTitle: string;
  translatedCategoryTitle: string;
  frameworks?: ReportingFrameworks;
};

export type EnhancedEsgKpi = EsgKpi & {
  childrens: EsgKpi[];
};

export type ActiveEnhancedKpi = EsgKpi & {
  esgValue: EsgValue;
  translatedKpiTitle: string;
  translatedCategoryTitle: string;
  frameworks?: ReportingFrameworks;
};
